import React from 'react';
import classnames from 'classnames';

// Constants
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

// Styles
import './SignUpTermsAgreement.scss';

type Props = {
  className?: string;
  prefixText?: string;
};

const SignUpTermsAgreement = ({ prefixText = 'By signing up', className }: Props) => {
  const { isZoom } = useApp();

  const handleTermsOfServiceClick = event => {
    if (isZoom) {
      event.preventDefault();
      (window as any).zoomSdk.openUrl({ url: `${window.location.origin}/terms_of_service` });
    }
  };

  const handlePrivacyPolicyClick = event => {
    if (isZoom) {
      event.preventDefault();
      (window as any).zoomSdk.openUrl({ url: `${window.location.origin}/privacy_policy` });
    }
  };

  const baseClassName = 'SignUpTermsAgreement';
  const classes = classnames(baseClassName, className);
  return (
    <p className={classes}>
      {prefixText}, you agree to The Predictive Index&apos;s{' '}
      <a
        href={ExternalLinksConstants.terms_of_service}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleTermsOfServiceClick}
      >
        Terms of Service
      </a>{' '}
      and{' '}
      <a
        href={ExternalLinksConstants.privacy_policy}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handlePrivacyPolicyClick}
      >
        Privacy Policy
      </a>
      .
    </p>
  );
};

export default SignUpTermsAgreement;
